import { getDisyNamespace } from '@disy/lib/disy';
import { loaderI18n as commonLoaderI18n } from '@disy/lib/i18n';

import { isFeatureAvailable } from 'cadenza/features';

const customPrefix = 'custom:';

// Note: If you do changes here, you probably need to do similar changes to PebbleI18Function.java.
export function loaderI18n(this: Record<string, string>, key = '', options: Record<string, unknown> = {}): string {
  if (key.startsWith(customPrefix)) {
    return customI18n(key.substr(customPrefix.length), options);
  }

  let text = commonLoaderI18n.call(this, key, options);

  if (!isFeatureAvailable('SHOW_I18N_TILDES')) {
    text = text.replace(/^~/, '');
  }
  return text;
}

function customI18n(key: string, options?: Record<string, unknown>) {
  return loaderI18n.call(getDisyNamespace().customMessages!, key, options);
}
